import { Request } from '../request'
import axios from 'axios'
let baseUrl = 'http://www.icitychina.net/digicity/app'
import vue from '../../main'

export function ChatSession(data){
    return axios({
        url: baseUrl + '/reading_service/boutique/home/getWxResult',
        method: 'post',
        data,
        headers: {'Content-Type': 'application/json'},
        cancelToken: new axios.CancelToken(function (c) {
            vue.prototype.$cancel = c
        })
    })
}

export function GetArticleList(data){
    return axios({
        url:'http://www.icitycloud.com.cn/digicity/app/search_service/gpt/journalsearch/getHanlpResult',
        method:'post',
        data
    })
}

export function GetArticleListDetail(params){
    return axios({
        url:'http://www.icitycloud.com.cn/digicity/app/search_service/gpt/journalsearch/getArticleDetailResult',
        method:'post',
        headers: { 'Content-Type': 'application/json' },
        params
    })
}
